import { ActivatedRoute, Router } from '@angular/router';

import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { selectAuthFetching, selectAuthMessage, selectAuthLoggedIn } from 'src/app/common/store/state/app.state';
import { AuthActions } from 'src/app/common/store/actions/auth.actions';
import { SignupCredentials, LoginCredentials } from 'src/app/public/account/models/auth-credentials.model';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginComponent implements OnInit {
  
  nextUrl = '';
 
  signupMode = false;
  recoverMode = false;
  submitText = this.signupMode ? "Signup":"Login";

  dealerTypes = ["PERSONAL", "PROFESSIONAL"];
  
  authForm: FormGroup = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl(''),
    dealerType : new FormControl(this.dealerTypes[0], Validators.required),
  });

  loggedIn$: Observable<boolean>;
  fetching$: Observable<boolean>;
  authFeedback$: Observable<string>;
  
  constructor(

    private store: Store,
    private router: Router, 
    private route: ActivatedRoute) {

      this.loggedIn$ = store.select(selectAuthLoggedIn);
      this.fetching$ = store.select(selectAuthFetching);
      this.authFeedback$ = store.select(selectAuthMessage);
    }

  ngOnInit(): void {

    //alert("route init = "+this.route.pathFromRoot?.);

    this.route.queryParams.subscribe(params => {
      this.nextUrl = params['next'];
      //alert(this.nextUrl);
    });
    
    this.loggedIn$.subscribe( loggedIn => {

        if(loggedIn){

          //this.router.navigate(['']);

          if(this.nextUrl == undefined ){
            this.router.navigate(['account']);
            return;
          }

          let str = this.nextUrl!.split('?');
          //console.log('URL = '+this.nextUrl);
          //console.log('URL link = '+str[0]);
          //console.log('URL params = '+str[1]) ; 
          //console.log('URL 222 = '+this.getParams(str[1]));
          //console.log('URL 222 = '+JSON.stringify(this.getParams('http://www.abc.com'+decodeURIComponent(this.nextUrl))));
          
          let urlRoute = this.nextUrl!.split('?')[0];
          let urlParams = this.getParams('http://www.aaa.com'+decodeURIComponent(this.nextUrl));

          //console.log('URL link = '+urlRoute);
          //console.log('URL params = '+JSON.stringify(urlParams)) ;

          this.router.navigate(
            [''+decodeURIComponent(urlRoute)],
            { queryParams: urlParams }
          );
        }
    }); 
  }

  toggleSignupMode(){
    this.signupMode = !this.signupMode;
  }

  toggleRecoverMode(){
    this.recoverMode = !this.recoverMode;
  }

  submitAuthForm(): void {
    if (this.authForm.valid) {
      
      this.store.dispatch(AuthActions.logoutSubmit());

      if(this.signupMode){

        console.log('signup')
        
        let cred: SignupCredentials = JSON.parse(JSON.stringify(this.authForm.value));
        this.store.dispatch(AuthActions.signupSubmit({signupCredentials: cred}));
      }
      else{
        console.log('login')
        
        let cred: LoginCredentials = JSON.parse(JSON.stringify(this.authForm.value));
        this.store.dispatch(AuthActions.loginSubmit({loginCredentials: cred}));
      }

      //console.log (" signup for usn = "+this.authForm.value.username)
     

    } 
  }

  submitRecoverForm(): void {

      this.store.dispatch(AuthActions.logoutSubmit());

      this.store.dispatch(AuthActions.recoverPasswordSubmit({username: this.authForm.value.username}));

      //console.log (" recover for usn = "+this.authForm.value.password)


  }  

  getParams (url: string) {

    // Create a params object
    let params: any = {};
  
    new URL(url).searchParams.forEach(function (val, key) {
      if (params[key] !== undefined) {
        if (!Array.isArray(params[key])) {
          params[key] = [params[key]];
        }
        params[key].push(val);
      } else {
        params[key] = val;
      }
    });
  
    return params;
  
  }
  
}